const key = "stepwise-product-options";

export const stepwiseProductOptions = {
    key: key,
    init: (value) => {

        let styleEl = document.getElementById(`${key}-style`);
        if(!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = `${key}-style`
            // Append <style> element to <head>
            document.head.appendChild(styleEl);
        }
        
        const styleSheet = styleEl.sheet;
        if(value){
            styleSheet.insertRule(`
                .option:not(.option--selected) + .option:not(.option--selected){
                    display: none;
                }`, 0);
        }   
    }
}
